module.exports = __webpack_public_path__ + "static/media/sideMatCharcoalGrey95.02baa124.png";